import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class MyProfileApis {
  static getProfile = async (req_data) => {
    const url = `${process.env.AE_API_URL}api/v1/candidates/my_profile`;
    const headers = apiHeaders(req_data);
    const res = await fetch(url, {
      method: 'GET',
      headers
    });

    return res;
  };

  static updateProfile = async (data) => {
    const reqBody = data;
    const url = `${process.env.AE_API_URL}api/v1/candidates/update`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static createProfile = async (data) => {
    const reqBody = data;
    const url = `${process.env.AE_API_URL}api/v1/candidates/create`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };
}
